import React, { useEffect, useState } from "react";
// import useReactRouter from "use-react-router"
import * as _ from "lodash"
import { Table } from "react-bootstrap";
import { imageRender, thousandSeperate } from "../../../helpers";
// import { GET_ORDERS } from "../../../graphql/order/query";
// import { useLazyQuery } from "@apollo/client";
// import { GET_POST_STOCKS } from "../../../graphql/postStock/query";
import PaginationsV1 from "../../../components/PaginationV1";

function LiveDetailSummary({ postDetailSummary, liveData, totalOrder, page, rowsPerPage, pageAll, handleChangePage }) {
    // const [liveOrderList, setLiveOrderList] = useState([]);
    // const [liveStockList, setLiveStockList] = useState([]);
    const [liveProductSummary, setLiveProductSummary] = useState([]);
    // const [totalAmount, setTotalAmount] = useState(0);
    // const [getOrderData, { data: orderData }] = useLazyQuery(GET_ORDERS, { fetchPolicy: "cache-and-network" });
    // const [getLiveStockData, { data: liveStockData }] = useLazyQuery(GET_POST_STOCKS, { fetchPolicy: "cache-and-network" });

    useEffect(() => {
        modifyData();
    }, [postDetailSummary])

    const modifyData = async () => {

        let _liveProductSummary = []

        // set post detail summary 
        _liveProductSummary = postDetailSummary.map((orders) => {
            return {
                stock: orders[0]?.postStock?.stock ?? {},
                count: orders?.reduce((sumAmount, order) => {
                    return sumAmount + order?.amount
                }, 0),
                price: orders[0]?.price,
                totalPrice: orders?.reduce((sumPrice, order) => {
                    return sumPrice + (order?.amount * order?.price)
                }, 0),
                currency: orders[0]?.currency ?? "ກີບ",
                cfMessage: orders[0]?.cfMessage
            }
        })
        setLiveProductSummary(_liveProductSummary)

        //set total price
        // let _newTotalPrice = _liveProductSummary?.reduce((sumPrice, order) => {
        //     return sumPrice + order?.totalPrice
        // }, 0)
        // setTotalAmount(_newTotalPrice);
    }

    return (
        <div>
            <div style={{ height: 10 }} />
            <br />
            <div style={{ background: "#fff", borderRadius: 5, padding: 12 }}>
                <p style={{ fontSize: 20, margin: 0 }}>ລາຍການສິນຄ້າທີ່ຂາຍໄດ້</p>
                <Table responsive className="staff-table-list borderless table-hover">
                    <thead style={{ background: "#F1F1F1" }}>
                        <tr style={{ whiteSpace: 'nowrap' }}>
                            <th style={{ borderBottom: "none" }}>ລ/ດ</th>
                            <th style={{ borderBottom: "none" }}>ຮູບ</th>
                            <th style={{ borderBottom: "none" }}>ຊື່ສິນຄ້າ</th>
                            <th style={{ borderBottom: "none" }}>ລະຫັດ CF</th>
                            <th style={{ borderBottom: "none" }}>ຂາຍໄດ້</th>
                            <th style={{ borderBottom: "none" }}>ລາຄາ</th>
                            <th style={{ borderBottom: "none" }}>ລວມເງິນ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {liveProductSummary && liveProductSummary?.map((lStock, index) => {
                            return <tr key={index} style={{ whiteSpace: 'nowrap' }}>
                                <td>{index + 1}</td>
                                <td><img src={imageRender(lStock?.stock?.image)} style={{
                                    borderRadius: "50%",
                                    height: 50,
                                    width: 50,
                                }} /></td>
                                <td>
                                    {lStock?.stock?.name}
                                </td>
                                <td>{lStock?.cfMessage}</td>
                                <td>{lStock?.count ?? 1}</td>
                                <td>{thousandSeperate(lStock?.price ?? lStock?.stock?.price)}</td>
                                <td>{thousandSeperate(lStock?.totalPrice ?? 0)} {lStock?.currency}</td>
                            </tr>
                        })}
                    </tbody>
                </Table>


                <PaginationsV1
                    count={totalOrder}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    pageAll={pageAll}
                    onPageChange={handleChangePage}
                />

            </div >

            <div style={{ height: 100 }} />
        </div >
    );
}

export default LiveDetailSummary;